import { render, staticRenderFns } from "./NotificationsSection.vue?vue&type=template&id=1bdcc49a&scoped=true&"
import script from "./NotificationsSection.vue?vue&type=script&lang=js&"
export * from "./NotificationsSection.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSection.vue?vue&type=style&index=0&id=1bdcc49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdcc49a",
  null
  
)

export default component.exports